window.setResponsiveImage = (b) => {
    
    let breakpoint = b;
    if ( ["xs", "sm", "md", "lg"].indexOf(breakpoint) == -1 ) {
        breakpoint = "lg";
    }

    let res = ( ["xs", "sm"].indexOf(breakpoint) >= 0 ) ? "m" : "d";
    let nodes = document.querySelectorAll("[data-responsiveimg]");

    nodes = nodes.toArray();
    nodes.forEach((node, i) => {
        let img = JSON.parse(node.getAttribute('data-ResponsiveImg').replace(/'/g, '\"'));
        if (img[res].trim() != "") {
            node.style.backgroundImage = 'url(' + img[res] + ')';
        }
    })
}